var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33333 0C5.70153 0 6 0.298477 6 0.666667V1H9.33333V0.666667C9.33333 0.298477 9.6318 0 10 0C10.3682 0 10.6667 0.298477 10.6667 0.666667V1H14V0.666667C14 0.298477 14.2985 0 14.6667 0C15.0349 0 15.3333 0.298477 15.3333 0.666667V1C17.9107 1 20 3.08933 20 5.66667V15.3333C20 17.9107 17.9107 20 15.3333 20H4.66667C2.08934 20 0 17.9107 0 15.3333V5.66667C0 3.08933 2.08934 1 4.66667 1V0.666667C4.66667 0.298477 4.96513 0 5.33333 0ZM13 11.3333C13.3682 11.3333 13.6667 11.0349 13.6667 10.6667C13.6667 10.2985 13.3682 10 13 10H7C6.6318 10 6.33333 10.2985 6.33333 10.6667C6.33333 11.0349 6.6318 11.3333 7 11.3333H13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteNote);
export default __webpack_public_path__ + "static/media/delete-note.903a337d84c29286b29803aa61ad1241.svg";
export { ForwardRef as ReactComponent };